import BaseApi from '@/api/Base/BaseApi'
import {
  UpdateModelPipelineGateNodePayload,
  GetGateNodeDetailResponse,
  CreateGateNodePayload
} from '@/api/GateNode/types'

const ROOT = '/gate'

export default class GateNodeApi extends BaseApi {
  getGateNode(gateNodeId: string) {
    return this.agent.get<GetGateNodeDetailResponse>(`${ROOT}/${gateNodeId}`)
  }

  updateGateNode(payload: UpdateModelPipelineGateNodePayload) {
    const { gateNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${gateNodeId}`, rest)
  }

  // FIXME: 임시
  runCrop(gateNodeId: string) {
    return this.agent.post(`${ROOT}/${gateNodeId}/crop`)
  }

  createGateNode(payload: CreateGateNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/gate/create`, rest)
  }
}
